import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import ClazzFields from './ClazzFields'

export const ClazzEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar />}>
      <Grid container spacing={8}>
        <ClazzFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default ClazzEdit
